import {notifyError} from '../components/Toast'
import { isValidTokenFormat, isTokenExpiringSoon } from '../utils/authUtils';


export const UserLogin = (credentials) => {
  return async (dispatch) => {
    dispatch({ type: 'LOGIN_REQUEST' });

    let payload = {
      returnurl:"URL_DASHBOARD",
      username: credentials.username,
      password: credentials.password,
      appid:"pei"
    }

    try {

      const response = await fetch(`${process.env.REACT_APP_API_LOGIN_URL}`, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: {
              'Content-Type': 'application/json',
          },
      });
    
      if(response.ok){

        const data = await response.json();
        const user = {
          username: data.userName, 
          userid: data.id,
          usermail:data.userid,
          token: data.token,
          roles: data.roles
        };

        dispatch({ type: 'LOGIN_SUCCESS', payload: user });

      }else if (response.status === 401 || response.status === 402) {        
        notifyError('Usuario o Contraseña incorrecto')
        const errorData = await response.json();
        dispatch({ type: 'LOGIN_FAIL', payload: errorData });
      }
      else{
        const errorData = await response.json();
        dispatch({ type: 'LOGIN_FAIL', payload: errorData.message || 'Error desconocido' });
      }

    } catch (error) {
        dispatch({ type: 'LOGIN_FAIL', payload: error.message });
    }
  };
};

export const GetUserPermissions = (user) => {
  return async (dispatch) => {
    dispatch({ type: 'PERMISSIONS_REQUEST' });
    
    try {

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}permissions/users?mail=&userId=${user.userid}&categoria=`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);
    
      if(response.ok){

        const data = await response.json();
        const rawList = data[0]?.permisos || [];
        const permissions = Object.values(rawList).map((perm) => ({
          ...perm,
          displayName: `${perm.cargo?.descripcion} - ${perm.permiso?.EntityId}${
            perm.sede?.codigo !== "ALL" ? ` - ${perm.sede?.codigo}` : ""
          }`,
        }));
        
        dispatch(SetActivePermission(permissions[0] || null));
        dispatch({ type: 'PERMISSIONS_SUCCESS', payload: permissions });

      } else{
        const errorData = await response.json();
        dispatch({ type: 'PERMISSIONS_FAIL', payload: errorData.message || 'Error desconocido' });
      }

    } catch (error) {
      dispatch({ type: 'PERMISSIONS_FAIL', payload: error.message });
    }
  };
};

export const SetActivePermission = (permiso) => {
  return (dispatch) => {
    dispatch({ type: 'PERMISSION_CHANGED_CLEAR_STATE' });

    dispatch({
      type: 'SET_ACTIVE_PERMISSION',
      payload: permiso,
    });
  };
};
  
export const UserLogout = () => {
  return (dispatch) => {
    //SE DEBE LIMPIAR el store cuando SALE DE LA APP
    localStorage.removeItem('persist:root');
    
    // Dispatch del logout
    dispatch({
      type: 'LOGOUT',
    });
  };
};

// Función para validar token automáticamente al iniciar la app
export const validateStoredToken = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const { user, isAuthenticated } = state.auth;
    
    // Si no hay usuario autenticado, no hacer nada
    if (!isAuthenticated || !user || !user.token) {
      return;
    }

    // Validar formato del token
    if (!isValidTokenFormat(user.token)) {
      console.warn('Token con formato inválido, haciendo logout');
      dispatch(UserLogout());
      return;
    }

    // Verificar si el token está próximo a expirar
    if (isTokenExpiringSoon(user.token)) {
      console.warn('Token próximo a expirar, renovando...');
      // Aquí podrías implementar renovación automática del token
    }

    try {
      // Validar token con el backend usando un endpoint existente
      // Puedes cambiar esto por cualquier endpoint que requiera autenticación
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}permissions/users?mail=&userId=${user.userid}&categoria=`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.token}`
        },
      });

      if (response.ok) {
        // Token válido, cargar permisos automáticamente
        dispatch(GetUserPermissions(user));
      } else {
        // Token inválido, hacer logout
        console.warn('Token inválido en el servidor, haciendo logout');
        dispatch(UserLogout());
      }
    } catch (error) {
      console.error('Error validando token:', error);
      // En caso de error de red, mantener la sesión pero mostrar advertencia
      // Solo hacer logout si es un error específico de autenticación
      if (error.message.includes('401') || error.message.includes('403')) {
        dispatch(UserLogout());
      }
    }
  };
};
  